import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import DictionaryForm from "@/components/dictionaries/DictionaryForm";
import Field from "@/components/Field";
import Fieldset from "@/components/Fieldset";
import PageContent from "@/components/PageContent";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { isRequired } from "@/lib/form";
import { useAgreementCompaniesDictionary } from "@/modules/agreement-companies/hooks/useAgreementCompaniesDictionary";
import { useTranslation } from "react-i18next";
import SaveButton from "@/components/SaveButton";

interface AgreementCompanyFormProps {
  footer?: React.ReactNode;
}

export default function AgreementCompanyForm({
  footer = <SaveButton />,
}: AgreementCompanyFormProps) {
  const { t } = useTranslation();
  const config = useAgreementCompaniesDictionary();
  const { Icon, ns } = config;
  const labels = config.getLabels(t);
  const { mutation } = useDictionaryContext();

  return (
    <DictionaryForm>
      <PageContent
        icon={<Icon className="w-6 h-6 mr-3" />}
        title={labels.title}
        footer={footer}
      >
        <Fieldset className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Field
            name="name"
            label={t(`${ns}.fields.name`)}
            required={isRequired(config.schema.shape.name)}
            render={({ field }) => (
              <Input
                disabled={mutation.isPending}
                className="w-full"
                {...field}
              />
            )}
          />
          <Field
            name="full_name"
            label={t(`${ns}.fields.full_name`)}
            required={isRequired(config.schema.shape.full_name)}
            render={({ field }) => (
              <Input
                disabled={mutation.isPending}
                className="w-full"
                {...field}
              />
            )}
          />
          <Field
            name="description"
            label={t(`${ns}.fields.description`)}
            required={isRequired(config.schema.shape.description)}
            render={({ field }) => (
              <Textarea
                disabled={mutation.isPending}
                className="w-full"
                {...field}
              />
            )}
          />
        </Fieldset>
      </PageContent>
    </DictionaryForm>
  );
}
